define('CustomMerchZone.Slide.View',
  [
    'SCView',
    'CustomMerchZone.Pricing.View',
    'custom_merch_zone_slide_view.tpl'
  ],
  function (
    SCViewComponent,
    CustomMerchZonePricingView,
    Template
  ) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function CustomMerchZoneSlideView(options) {
      SCView.call(this);

      this.options = options || {};

      this.template = Template;

      this.initialize = function initialize(opts) {
        this.model = opts.model;
      };

      this.initialize(options);
    }

    CustomMerchZoneSlideView.prototype = Object.create(SCView.prototype);

    CustomMerchZoneSlideView.prototype.constructor = CustomMerchZoneSlideView;

    CustomMerchZoneSlideView.prototype.getChildViews = function () {
      return {
        'CustomMerchZone.Pricing': function () {
          return new CustomMerchZonePricingView({
            // container: this.container,
            pricingConditionsInformation: this.model && this.model.get('pricingInformation') || {},
            isLoggedIn: this.model && this.model.get('isLoggedIn') || false,
            merchZoneConfig: this.model && this.model.get('merchZoneConfig') || {},
            price: this.model && this.model.get('price') || '',
            priceNoFormatted: this.model && this.model.get('priceNoFormatted') || '',
            customRolesConfig: this.model && this.model.get('customRolesConfig') || {},
            role: this.model && this.model.get('customerRole') || '',
            itemIsInStock: this.model && this.model.get('isInStock'),
            model: this.model
          });
        }
      };
    };

    CustomMerchZoneSlideView.prototype.getContext = function () {
      return {
        urlComponent: this.model && this.model.get('urlComponent') || '',
        image: this.model && this.model.get('image') || '',
        itemId: this.model && this.model.get('itemId') || '',
        itemName: this.model && this.model.get('itemName') || '',
        site: this.model && this.model.get('site')
      };
    };
    return CustomMerchZoneSlideView;
  });
